import React, { createContext, useContext } from "react";

// Contexto para identificar se estamos no layout moderno
const ModernLayoutContext = createContext(false);

export const ModernLayoutProvider = ({ children }) => {
  return (
    <ModernLayoutContext.Provider value={true}>
      {children}
    </ModernLayoutContext.Provider>
  );
};

export const useModernLayout = () => {
  return useContext(ModernLayoutContext);
};

export default ModernLayoutContext;

